<template>
  <div class="homeview">
    <!-- 导航栏 -->
    <tag/>
    <!-- 轮播图 -->
    <div class="carousel">
      <el-carousel trigger="click" :height="bannerHeight+'px'">
        <el-carousel-item v-for="item in carousel" :key="item.id">
          <img ref="bannerHeight" @load="imgLoad" style="object-fit:cover;width: 100vw;height:100vh;"
               :src="item.url" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="customer">
      <!-- 标题 -->
      <div class="titlee">
        <span>COSTOMER</span>
        <div class="titlee1">
          <h1>合作客户</h1>
          <div class="bot-titlee">
            <div class="bot-titlee1"></div>
            <div class="bot-titlee2"></div>
          </div>
        </div>
      </div>
      <!-- 合作对象logo展示 -->
      <div class="exhibition">
        <el-row :gutter="40" type="flex" class="row-bg" justify="center">
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/lzlg.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/lzyh.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/swzq.png" />
          </el-col>
        </el-row>
        <el-row :gutter="40" type="flex" class="row-bg" justify="center">
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/xnykdx.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/lzzyy.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/lxzyy.png" />
          </el-col>
        </el-row>
        <el-row :gutter="40" type="flex" class="row-bg" justify="center">
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/hjrmyy.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/tfzx.png" />
          </el-col>
          <el-col :span="6">
            <img src="http://imgcdn.scxdzc.com/scxdzhongchuang/lugao.png" />
          </el-col>
        </el-row>
      </div>
      <!-- 合作数量 -->
      <div class="exhibition-number">
        <div class="number1">
          <h1>35+</h1>
          <span>政府领域</span>
        </div>
        <div class="number1">
          <h1>13+</h1>
          <span>民生领域</span>
        </div>
        <div class="number1">
          <h1>10+</h1>
          <span>医疗领域</span>
        </div>
        <div class="number1">
          <h1>20+</h1>
          <span>教育领域</span>
        </div>
        <div class="number1">
          <h1>2+</h1>
          <span>金融领域</span>
        </div>
      </div>
    </div>
    <!-- 公司简介 -->
    <div class="intro">
      <el-row>
        <el-col :span="8" style="display: flex;justify-content: center;align-items: center">
          <!-- 标题 -->
          <div class="titlee">
            <span>COMPANY</span>
            <div class="titlee1">
              <h1>公司简介</h1>
              <div class="bot-titlee">
                <div class="bot-titlee1"></div>
                <div class="bot-titlee2"></div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16" class="content">
          <!-- 简介 -->
          <span>四川信达中创科技发展有限公司（简称“信达中创”），是一家专注于科技创新并且讲究诚信的企业。其中“信达”体现了企业在诚信方面的追求；“中创”则代表了企业在科技创新方面的能力和实力，同时也突出了企业的国内背景。整个名称通俗易记，表达了企业的主营业务和核心价值观。</span>
          <p>—— ChatGPT</p>
          <button>查看更多</button>
        </el-col>
      </el-row>
      <div class="intro2">
          <div class="grid-content">
            <div class="number1-tag">
              <div class="intro2-num-title">
                <div class="intro2-num">51&nbsp;</div>
                <div class="intro2-num-one">人</div>
              </div>
              <div class="intro-num-body">
                <span>现有员工</span>
                <img class="intro-num-body-image" src="../assets/img/intro/every-user.png">
              </div>
            </div>
          </div>
          <div class="grid-content">
            <div class="number1-tag">
              <div class="intro2-num-title">
                <div class="intro2-num">2000&nbsp;</div>
                <div class="intro2-num-one">万</div>
              </div>
              <div class="intro-num-body">
                <span>注册资金</span>
                <img class="intro-num-body-image" src="../assets/img/intro/funds.png">
              </div>
            </div>
          </div>
         <div class="grid-content">
            <div class="number1-tag">
              <div class="intro2-num-title">
                <div class="intro2-num intro-num-font-two" style="">2002&nbsp;</div>
              </div>
              <div class="intro-num-body">
                <span>成立时间</span>
                <img class="intro-num-body-image" src="../assets/img/intro/city-one.png">
              </div>
            </div>
          </div>
      </div>
    </div>
<!--    公司标签-->
    <div class="banner-ft">
      <div class="banner-body">
        <div class="banner-left">
          <div class="banner-left-font">
            <div class="banner-left-one">
              从未发生过一次故意拖欠员工薪水的行为
            </div>
            <div class="banner-left-two">
              1998年～2023年，在信达中创经营发展的25年，持续做到了<p style="font-weight: 700;display: inline-block;margin: 0px;">每个月按时发放薪水</p>
            </div>
          </div>
        </div>
        <div class="banner-right">
          <div class="banner-left-font">
            <div class="banner-left-one">
              疫情期间实现平均收入增长
            </div>
            <div class="banner-left-two">
              2020年～2022年，在全国新冠疫情发生的三年期间，扣除公司高层管理人员收入之后，信达中创普通员工的收入<p style="font-weight: 700;display: inline-block;margin:0px;">平均增长12%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    核心业务-->
<!--    <div class="core">-->
<!--      <div class="two-body-title">-->
<!--        <div class="two-body-title-one">BUSINESS</div>-->
<!--        <div class="two-body-title-two">核心业务</div>-->
<!--        <div class="two-body-title-third">-->
<!--          <div class="two-body-title-third-borde"></div>-->
<!--          <div class="two-body-title-third-border"></div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="core-body">-->
<!--          <div v-for="(item,index) in coreTag" :key="index" class="grid-content-image bg-purple">-->
<!--           <img class="grid-content-image-style"  :src="item.imageUrl"/>-->
<!--            <div class="core-title">-->
<!--              {{item.title}}-->
<!--            </div>-->
<!--          </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    邀请加入-->
    <div class="invot">
      <div class="invot-body">
         <img class="invot-body-image" src="../assets/LOGO-red.png">
        <div class="invot-font">信达中创诚邀您的加入</div>
        <div class="invot-call-phone">0830-3192239</div>
      </div>
    </div>
<!--    最后一页-->
    <div class="footer-margin">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Tag from "@/views/tag"
import Footer from "@/views/footer";
export default {
  name: 'HomeView',
  components: {
    Tag,
    Footer
  },
  data() {
    return {
      bannerHeight: " ",
      activeIndex: '1',
      mode:'',
      carousel: [{
        id: 1,
        url: 'http://imgcdn.scxdzc.com/scxdzhongchuang/carousel_11.png',
      },
        {
          id: 2,
          url: 'http://imgcdn.scxdzc.com/scxdzhongchuang/carousel_22.png',
        },
        {
          id: 3,
          url: 'http://imgcdn.scxdzc.com/scxdzhongchuang/carousel_33.png',
        },
        {
          id: 4,
          url:'http://imgcdn.scxdzc.com/scxdzhongchuang/carousel_44.png',
        },
        {
          id: 5,
          url: 'http://imgcdn.scxdzc.com/scxdzhongchuang/carousel_55.png',
        },
      ],
    }
  },
  methods: {
    imgLoad() {
      this.$nextTick(() => {
        if(this.$refs.bannerHeight.length != 0){
          this.bannerHeight = this.$refs.bannerHeight[0].height
          // console.log(this.$refs.bannerHeight[0].height)
        }
      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  created() {
    this.imgLoad();
    window.addEventListener('resize', () => {
      if(this.$refs.bannerHeight.length != 0){
        this.bannerHeight = this.$refs.bannerHeight[0].height
        this.imgLoad();
      }
    }, false)
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }
}
</script>

<style scoped lang="scss">
$back-color: #FFFFFF;
$font-color: #000000;
$title-color: #343434;
$title1-color: #CCCCCC;
$main-color: #E62129;
div {
  font-family: HarmonyOS_Sans_Black;
}
p {
  font-family: HarmonyOS_Sans_Black;
}
.homeview {
  width: 100%;
  height: auto;
}

.carousel {
  width: 100%;
  height: auto;
}

.titlee {
  width: 160px;
  line-height: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    color: $title1-color;
    font-size: 18px;
    font-weight: lighter;
  }

  .titlee1 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    h1 {
      color: $title-color;
      font-size: 40px;
      font-weight: bold;
    }

    .bot-titlee {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: center;

      .bot-titlee1 {
        width: 58px;
        height: 4px;
        background-color: $main-color;
        border-radius: 20px;
      }

      .bot-titlee2 {
        width: 4px;
        height: 4px;
        background-color: $main-color;
        margin-left: 4px;
        border-radius: 50%;
      }
    }
  }

}
.customer {
  width: 100%;
  height: auto;
  margin: 100px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .exhibition {
    width: 90%;
    padding: 100px 0px 44px 0px;

    .el-row {
      margin-bottom: 32px;

      .el-col {
        width: 250px;
        height: auto;

        img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }

  .exhibition-number {
    width: 90%;
    height: auto;
    background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back%20domain.png");
    background-size: cover;
    color: $back-color;
    border-radius: 15px;
    padding: 48px 0px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    .number1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      h1 {
        font-size: 40px;
        font-weight: bold;
      }

      span {
        font-size: 16px;
        margin-top: 24px;
      }
    }
  }
}
.intro {
  width: 100%;
  //height: auto;
  min-height: 1090px;
  background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back%20middle1.png");
  background-size: 100% 100%;
  //margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .el-row {
    width: 90%;
    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 375px) {
      .el-row {
        flex-direction: column;
        flex-wrap: nowrap;
      }
    }

    .content {
      max-width: 100%;
      height: auto;
      padding: 72px 72px 154px 72px;
      background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back%20about.png");
      background-size: cover;
      color: $back-color;
      display: flex;
      flex-direction: column;
      border-radius: 15px;

      span {
        font-size: 18px;
        text-align: left;
        line-height: 36px;
      }

      p {
        text-align: right;
      }

      button {
        color: $back-color;
        font-size: 14px;
        width: 104px;
        height: 35px;
        background-color: $main-color;
        border-radius: 20px;
        border: 0px;
        margin-top: 72px;
      }
    }
  }
  .intro2{
    margin-top: 120px;
    //display: flex;
    display: grid;
    grid-template-columns:repeat(auto-fit, minmax(160px, 1fr));
    width: 100%;
    .grid-content{
      //height: auto;
      //width: 158px;
      margin-top: 20px;
      height: 188px;
      display: flex;
      justify-content: center;
    }
    .number1-tag{
      display: flex;
      flex-direction: column;
      align-items: center;
      //width: 75px;
      .intro2-num-title{
        display: flex;
        //width: 75px;
        height: 53px;
        .intro2-num {
          color: rgb(52, 52, 52);
          font-size:40px;
          font-weight: 400;
          letter-spacing: 0px;
          text-align: center;
          text-transform: uppercase;
        }
        .intro-num-font-two{
          font-size: 64px;
          font-weight: 700 !important;
          color: rgb(230, 33, 41) !important;
          line-height: 84px !important;
          letter-spacing: 0px;
        }
        .intro2-num-one{
          font-size:16px;
          font-weight: 290;
          line-height: 4.4;
          letter-spacing: 0px;
          text-align: right;
          text-transform: uppercase;
        }
      }
      .intro-num-body{
        display: flex;
        flex-direction: column;
        margin-top: 48px;
        align-items: center;
        .intro-num-body-image{
          margin-top:16px;width: 24px;height: 24px;
        }
        span {
          font-size: 16px;
          margin-top: 24px;
        }
        width: 72px;
        height: 64px;
      }

    }
  }
}
.core{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  .two-body-title{
    width: 160px;
    height: 112px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .two-body-title-one{
      color: rgb(204, 204, 204);
      font-size: 18px;
      font-weight: 290;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
      text-transform: uppercase;
    }
    .two-body-title-two{
      margin-top: 16px;
      color: rgb(52, 52, 52);
      font-size: 40px;
      font-weight: 700;
      line-height: 53px;
      letter-spacing: 0px;
      text-align: center;
    }
    .two-body-title-third{
      margin-top: 16px;
      display: flex;
      flex-direction: row-reverse;
      width: 100%;
      .two-body-title-third-borde{
        border-radius: 10px;
        background: rgb(230, 33, 41);
        width: 4px;
        height: 4px;
      }
      .two-body-title-third-border{
        border-radius: 10px;
        background: rgb(230, 33, 41);
        width: 58px;
        height: 4px;
        margin-right: 4px;
      }
    }
  }
  .core-body{
    margin-top: 120px;
    display: grid;
    grid-template-columns: repeat(4,auto);
    row-gap: 8%;
    .grid-content-image{
      display: flex;
      width: 260px;
      height: 239px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .grid-content-image-style{
        max-width: 260px;
        height: 160px;
      }
    }
   .core-title{
     color: rgb(52, 52, 52);
     font-size: 24px;
     font-weight: 400;
     line-height: 32px;
     letter-spacing: 0px;
     text-align: left;
     margin-top: 48px;
   }
    .el-col-6{
      display: flex;
      justify-content: center;
      margin-top: 72px;
    }
  }
}
.middle{
  margin-top: 100px;
  max-width: 100%;
  //height: 394px;
  display: flex;
  justify-content: center;
  align-items: center;
  .middle-body{
    display: flex;
    width: 100%;
    //align-items: center;
    .biaodian{
      width: 10px;
      height: 10px;
      border: 1px solid rgb(255, 255, 255);
      border-radius: 50%;
      margin-left: 32px;
      margin-right: 32px;
      margin-bottom: 18px;
      margin-top: 18px;
    }
    .middle-body-tag{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      max-width: 102px;
      height: 81px;
      .middle-font{
        color: rgb(255, 255, 255);
        font-size: 36px;
        font-weight: 400;
        line-height: 47px;
        letter-spacing: 0px;
      }
      .middle-font-butom{
        margin-top: 16px;
        color: rgb(255, 255, 255);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: justify;
        text-transform: uppercase;
      }
    .middle-font-butom-two{
        width: 102px;
      }
    }
  }
}
.invot{
  margin-top: 160px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .invot-body{
    min-width: 378px;
    height: 218px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .invot-body-image{
      width: 140px;
      height: 83px;
    }
    .invot-font{
      color: rgb(52, 52, 52);
      font-size: 36px;
      font-weight: 400;
      line-height: 48px;
      letter-spacing: 2px;
      text-align: center;
      margin-top: 32px;
    }
    .invot-call-phone{
      color: rgb(52, 52, 52);
      font-size: 18px;
      font-weight: 290;
      line-height: 24px;
      letter-spacing: 2px;
      text-align: center;
      margin-top: 32px;
    }
  }
  .footer-margin{
    margin-top: 60px;
  }
}
.banner-ft{
  margin-top: 48px;
  max-width: 100%;
  display: flex;
  min-width: 1300px;
  justify-content: center;
  min-height: 330px;
  max-height: 360px;
  .banner-body,{
    width: 80%;
    display: flex;
    justify-content: space-between;
    .banner-left,.banner-right{
      height: 100%;
      width: 48%;
      background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back1.png");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      .banner-left-font{
        display: flex;
        flex-direction: column;
        width: 80%;
        min-height: 72px;
        max-height: 50%;
        .banner-left-one{
          color: rgb(255, 255, 255);
          font-size: 24px;
          font-weight: 700;
          line-height: 32px;
          letter-spacing: 0px;
        }
        .banner-left-two{
          margin-top: 32px;
          font-size: 20px;
          font-weight: 400;
          color: rgb(204, 204, 204);
          line-height: 32px;
          letter-spacing: 0px;
          text-align: justify;
        }
      }
    }
    .banner-right{
      //border-radius: 10px;
      //height: 100%;
      //width: 48%;
      background-image: url("http://imgcdn.scxdzc.com/scxdzhongchuang/back2.png") !important;
      //background-repeat: no-repeat;
      //background-position: center;
      //background-size: 100% 100%;
    }
  }
}
@media screen and (min-width: 0px) and (max-width: 570px) {
  .el-row{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .row-bg{
    flex-direction: row;
  }
  .titlee1{
    width: 170px;
  }
  .content{
    margin-top: 40px;
    width: 90%;
    padding: 20px 20px 72px 20px !important;
    span{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
}
@media screen and (max-width: 650px) {
  .core-body{
    width: 100% !important;
    justify-content: center;
    align-items: center;
    grid-template-columns: repeat(2,auto) !important;
    .grid-content-image{
      width: 100% !important;
      display: flex;
      height: auto !important;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .grid-content-image-style{
        max-width: 70% !important;
        height: 50% !important;
      }
      .core-title{
        font-size: 1.2rem !important;
      }
    }
    .core-title{
      color: rgb(52, 52, 52);
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      letter-spacing: 0px;
      text-align: left;
      margin-top: 48px;
    }
  }
  .middle{
    margin-top: 300px !important;
  }
  .invot{
    margin-top: 100px !important;
    .invot-font{
      font-size: 1.85rem !important;
    }
    .invot-call-phone{
      font-size: 1.1rem;
    }
  }
  .intro-num-font-two{
    font-size: 3rem !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 570px) {
  .banner-ft{
    max-height: 800px !important;
    min-width: 100% !important;
    .banner-right,.banner-left{
      width: 100% !important;
      .banner-left-font{
        max-height: 100% !important;
        width: 86% !important;
        margin-top: 12px;
        margin-bottom: 12px;
        .banner-left-one{
          font-size: 1.5rem !important;
        }
        .banner-left-two{
          margin-top: 12px!important;
          font-size: 1.1rem !important;
        }
      }
    }
    .banner-right{
      margin-top: 2vh;
    }
    .banner-body{
      flex-direction: column !important;
    }

  }
}
</style>
